export enum YesOrNoOrOther {
    no = 'Nee',
    other = 'Anders',
    yes = 'Ja',
}
